import Form from './form.vue';
import accessConfig from './accessConfig.vue';

export { Form, accessConfig };
